var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaCanada(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 45,
    viewBox: "0 0 60 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_188_9198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.9281 0H14.0813V45H45.9375L45.9281 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8467 0H45.9279V45H61.8467V0ZM14.0811 0H-1.83769V45H14.0717L14.0811 0ZM41.1561 21.75L42.4029 22.1625L36.6467 27.225C36.2061 28.5094 36.7967 28.8937 37.1717 29.5687L30.9279 28.7812L31.0779 35.0625L29.7748 35.0344L30.0654 28.7906L23.8123 29.5406C24.1967 28.725 24.5436 28.2937 24.1873 26.9906L18.4404 22.2094L19.4436 21.8344C20.2686 21.1969 19.0873 18.7781 18.9186 17.25C18.9186 17.25 22.2654 18.4031 22.4811 17.7938L23.3436 16.1531L26.3998 19.5094C26.7279 19.5938 26.8686 19.4625 26.9529 19.1813L25.5467 12.1688L27.7779 13.425C27.9654 13.5094 28.1529 13.4344 28.2654 13.2188L30.4217 8.90625L32.6342 13.3875C32.8029 13.5469 32.9717 13.5656 33.1029 13.4531L35.2498 12.2625L33.9654 19.2094C34.0686 19.4906 34.3123 19.5656 34.5936 19.4156L37.5186 16.1063C37.8936 16.7156 38.1561 17.7094 38.6623 17.9344C39.1686 18.15 40.8654 17.5125 41.9998 17.2781C41.6061 18.6656 40.4061 20.9906 41.1561 21.75Z",
    fill: "#D52B1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_188_9198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 45,
    fill: "white",
    transform: "matrix(-1 0 0 1 60 0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaCanada);
export default __webpack_public_path__ + "static/media/ca Canada.23e965374edcb9caeb9aaeb2359f0583.svg";
export { ForwardRef as ReactComponent };